'use client';
import React, { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function LoadingScreen() {
  // useEffect(() => {
  //   if (typeof gsap !== 'undefined') {
  //     gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

  //     ScrollTrigger.normalizeScroll(true);

  //     // create the smooth scroller FIRST!
  //     let smoother = ScrollSmoother.create({
  //       smooth: 2,
  //       effects: true,
  //     });
  //   }
  // }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      if (typeof gsap !== 'undefined') {
        clearInterval(interval);
        const svg = document.getElementById('svg');
        if (!svg) return;
        
        // Asegurar que el logo sea visible inmediatamente
        const logoElement = document.querySelector('.loader-wrap-heading .loader-logo');
        if (logoElement) {
          gsap.set(logoElement, { opacity: 1, scale: 1, y: 0 });
        }
        
        const tl = gsap.timeline();
        const curve = 'M0 502S175 272 500 272s500 230 500 230V0H0Z';
        const flat = 'M0 2S175 1 500 1s500 1 500 1V0H0Z';
        
        // Animación sutil de pulso mientras está visible
        tl.to('.loader-wrap-heading .loader-logo', {
          duration: 0.6,
          scale: 1.05,
          yoyo: true,
          repeat: 1,
          ease: 'power1.inOut',
        });
        
        // Esperar un momento antes de salir
        tl.to({}, { duration: 0.5 });
        
        // Animación de salida del logo
        tl.to('.loader-wrap-heading .loader-logo', {
          duration: 0.5,
          y: -50,
          opacity: 0,
          ease: 'power2.in',
        });
        
        // Animación del SVG
        tl.to(svg, {
          duration: 0.5,
          attr: { d: curve },
          ease: 'power2.easeIn',
        }).to(svg, {
          duration: 0.5,
          attr: { d: flat },
          ease: 'power2.easeOut',
        });
        
        // Ocultar el loader
        tl.to('.loader-wrap', { y: -1500 });
        tl.to('.loader-wrap', { zIndex: -1, display: 'none' });
        
        // Animación del header
        tl.from('header', { y: 200 }, '-=1.5');
        tl.from(
          'header .container',
          { y: 40, opacity: 0, delay: 0.3 },
          '-=1.5'
        );
      }
    }, 100);
  }, []);

  return (
    <>
      <style>{`
        .loader-wrap-heading .loader-logo {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          opacity: 1;
        }
        .loader-wrap-heading .loader-logo img {
          max-width: 200px;
          height: auto;
          object-fit: contain;
        }
        @media (max-width: 768px) {
          .loader-wrap-heading .loader-logo img {
            max-width: 150px;
          }
        }
      `}</style>
      <div className="loader-wrap">
        <svg viewBox="0 0 1000 1000" preserveAspectRatio="none">
          <path id="svg" d="M0,1005S175,995,500,995s500,5,500,5V0H0Z"></path>
        </svg>

        <div className="loader-wrap-heading">
          <div className="loader-logo">
            <img src="/assets/imgs/logo-light.png" alt="CITRICOS NATURALES SAS" />
          </div>
        </div>
      </div>
    </>
  );
}

export default LoadingScreen;
